export const ReservationVerificationColors = {
    PASSED: 'lightgreen',
    PROCESSING: '#b3e5fc',
    NO_VERIFICATION: 'lightgrey',
    CAUTION: '#0086c3',
    ERROR: '#778898'
}

export const ReservationStatusColors = {
    UPCOMING: '#d3d3d3',
    IN_HOME: '#ffdd00',
    COMPLETE: 'lightgreen',
    CLAIM_FILED: '#ED6C23',
    CANCELED: 'red'
}

export const GuestReservationVerificationResultStatus = {
    PROCESSING: 'PROCESSING',
    CAUTION: 'CAUTION',
    ERROR: 'ERROR',
    NO_VERIFICATION: 'NO VERIFICATION',
    PASSED: 'PASSED'
}

//TODO: merge this with the other ReservationStatus enum in Reservation.ts
//Not actually representative of the status values that are stored in SQL
//For instance, Completed is the correct status, not COMPLETE
export enum LegacyReservationStatus {
    UPCOMING,
    IN_HOME,
    COMPLETE,
    CANCELED,
    CLAIM_FILED,
    INVALID
}